<template>

<svg 
	 xmlns="http://www.w3.org/2000/svg"   
	 viewBox="-11.5 780.5 24 24" >
<path d="M0.5,782.5l10,9.99l-0.62,0.62L0.5,802.5l-10-10.01L0.5,782.5z M1.38,787.24h-1.75v5.25h1.75V787.24z M2.25,788.49v2.06
	c0.54,0.48,0.88,1.17,0.88,1.95c0,1.46-1.17,2.63-2.63,2.63c-1.46,0-2.63-1.17-2.63-2.63c0-0.78,0.34-1.47,0.88-1.95v-2.05
	c-1.54,0.68-2.63,2.22-2.63,4c0,2.41,1.97,4.38,4.38,4.38c2.41,0,4.38-1.97,4.38-4.38C4.88,790.71,3.79,789.17,2.25,788.49z"/>
</svg>

</template>